import {setJobEditCartItems} from "./jobEditActions";
import {DASHBOARD_MESSAGING_ACTIONS, sendIframePostMessage} from "./jobIframeMessaging";

const upperCaseAlp = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

const getCurrentQuoteRoomItem = (cartItems, quoteIndexToFind) => {
  return cartItems.find(cItem => (cItem.currentQuote === quoteIndexToFind) && (cItem.partId === "room"))
};

export const getCommonVisualizerType = (visualizerType) => {
  switch (visualizerType) {
    case "Bathroom":
    case "BV":
    case "bvScene":
    case "bvLook":
      return "bathroom";
    case "Kitchen":
    case "KV":
    case "kvMaster":
    case "kvScene":
      return "kitchen";
    case "Fireplace":
      return "fireplace";
    case "LaundryRoom":
      return "laundryroom";
    default:
      return visualizerType
  }
}

export const getVisualizerTypeFromSubscription = (subscription = "bathroom", toolVersion = 4) => {
  switch (subscription) {
    case "Bathroom":
    case "bathroom":
      return toolVersion === 6
        ? "bvLook"
        : toolVersion === 5 ? "bvScene" : "Bathroom"
    case "Kitchen":
    case "kitchen":
      return toolVersion === 5 ? "kvScene" : "Kitchen"
    case "Fireplace":
    case "fireplace":
      return "Fireplace"
    default:
      return subscription
  }
}

const quoteCurrentRoomName = (quoteObject, intl, records) => {
  const {cartItems, quoteIndex} = quoteObject;
  const roomCartItem = getCurrentQuoteRoomItem(cartItems, quoteIndex);
  if (roomCartItem && roomCartItem.cartFeature && roomCartItem.cartFeature.partName) {
    return roomCartItem.cartFeature.partName
  }
  if (records[quoteIndex] && records[quoteIndex].data && records[quoteIndex].data.visualizerType) {
    return intl.formatMessage({id: "wizard.subscription." + getCommonVisualizerType(records[quoteIndex].data.visualizerType)})
  }
  if (records[quoteIndex] && records[quoteIndex].room) {
    return intl.formatMessage({id: "wizard.subscription." + getCommonVisualizerType(records[quoteIndex].room)})
  }
  return ""
};

/**
 * @param neededCartItems {jobCartItemInterface[]}
 * @param jobCartItems {jobCartItemInterface[]}
 * @param property {string}
 * @param value {any}
 * @param dispatch {function}
 * @param iframeElement {any}
 * @return {array}
 */
export const updateCartItems = (
  neededCartItems,
  jobCartItems,
  property,
  value,
  dispatch,
  iframeElement
) => {
  const updatedCartItems = jobCartItems.map(jobCartItem => {
    const shouldUpdate = neededCartItems.some(cI => {
      return cI.id === jobCartItem.id || (jobCartItem.relatedProductParent && jobCartItem.relatedProductParent.dbFeature
        && (jobCartItem.relatedProductParent.dbFeature.id === cI.cartFeature.dbFeatureId))
    })
    if (shouldUpdate) {
      return {...jobCartItem, [property]: value}
    }
    return jobCartItem
  });
  // dispatch(setJobEditPopupIframeWaiting(true));
  dispatch(setJobEditCartItems(updatedCartItems));
  sendIframePostMessage(iframeElement, {
    action: DASHBOARD_MESSAGING_ACTIONS.updateCartItems,
    payload: {cartItems: updatedCartItems}
  });
}


/**
 * @param jobCartItems {jobCartItemInterface[]}
 * @param intl {object}
 * @param records {array}
 * @return {array}
 */
export const getRoomNames = (jobCartItems, intl, records = []) => {
  let namesIndexes = {} // Kitchen: 0, Bathroom: 1
  const quoteObjects = jobCartItems.reduce((quotes, cartItem) => {
    const existingQuote = quotes.find(quote => quote.quoteIndex === cartItem.currentQuote);
    if (existingQuote) {
      existingQuote.cartItems.push(cartItem);
    } else {
      quotes.push({
        quoteIndex: cartItem.currentQuote,
        cartItems: [cartItem],
      })
    }
    return quotes
  }, []);
  const baseNames = quoteObjects.map(quoteObject => quoteCurrentRoomName(quoteObject, intl, records));
  return baseNames.map((baseRoomName, baseRoomNameIndex) => {
    if (!namesIndexes[baseRoomName]) {
      namesIndexes[baseRoomName] = 0;
    }
    const weAlreadyHaveThisRoom = baseNames.find((roomName, roomNameIndex) => {
      return (roomName === baseRoomName) && (roomNameIndex !== baseRoomNameIndex)
    });
    if (weAlreadyHaveThisRoom) {
      const finalRoomName = baseRoomName + upperCaseAlp[namesIndexes[baseRoomName]]; // "Kitchen A"
      namesIndexes[baseRoomName] = namesIndexes[baseRoomName] + 1;
      return finalRoomName
    } else {
      return baseRoomName
    }
  })
};

/**
 * @param jobCartItems {jobCartItemInterface[]}
 * @param forQuoteIndex {number|null}
 * @param searchText {string}
 * @returns {jobEditGroupObjectInterface[]}
 * */
export const getRenderJobCartItemsGroupObjects = (jobCartItems, forQuoteIndex = null, searchText = "") => {
  const quotes = [];
  const lowerCasedText = searchText ? searchText.toLowerCase() : "";
  jobCartItems.forEach((cartItem) => {
    if (cartItem.partId === "room") {
      return;
    }
    if (searchText && (!cartItem.cartFeature.partName
      || !cartItem.cartFeature.partName.toLowerCase().includes(lowerCasedText))) {
      return
    }
    if ((typeof forQuoteIndex === "number") && (cartItem.currentQuote !== forQuoteIndex)) {
      return
    }
    const matchBy = cartItem.cartFeature.parentName || cartItem.cartFeature.groupName || cartItem.selectionGroup;
    const existingGroup = quotes.find(quote => quote.groupName === matchBy);
    if (existingGroup) {
      existingGroup.cartItems.push(cartItem);
    } else {
      quotes.push({
        groupName: matchBy,
        quoteIndex: cartItem.currentQuote,
        cartItems: [cartItem],
      })
    }
  });
  return quotes
}
